<template>
  <div class="iufo">
    <div class="top">
      <h2 class="name">综合报表</h2>
      <div class="content">
        <a-row>
          <a-form-model>

            <a-col span="8">
              <a-form-model-item label="日期">
                <a-date-picker valueFormat="YYYY-MM-DD" v-model="form.startDate" />
                <a-date-picker style="margin-left:20px" valueFormat="YYYY-MM-DD" v-model="form.endDate" />
                <a-button style="margin-left: 10px" @click="handleClick">查询</a-button>
              </a-form-model-item>
            </a-col>
            <!-- <a-col span="6">
              <a-form-model-item label=" " :colon="false">
                <a-date-picker valueFormat="YYYY-MM-DD" v-model="form.endDate" />
              </a-form-model-item>
              <a-button style="margin-left: 10px" @click="handleClick">查询</a-button>
            </a-col> -->
            <a-col span="4">
              <a-radio-group
                class="week-month-season-year"
                default-value="本周"
                v-model="currentDate"
                @change="handleChange"
                button-style="solid"
              >
                <a-radio-button value="本周"> 本周 </a-radio-button>
                <a-radio-button value="本月"> 本月 </a-radio-button>
                <a-radio-button value="本季"> 本季 </a-radio-button>
                <a-radio-button value="本年"> 本年 </a-radio-button>
              </a-radio-group>

            </a-col>
            <!-- <a-col span="10" >
              <div style="display:flex;justify-content: flex-end;">
                <a-form-model-item label="开关">
                  <a-switch v-model="switchValue" @change="switchChange" />
                </a-form-model-item>
              </div>

            </a-col> -->
          </a-form-model>
        </a-row>
      </div>
    </div>
    <div id="warpper_page_body" v-hasPermi="['statistics:comprehensiveStatistics:list']" class="bottom">
      <!-- <div class="results_wrapper"> -->
      <div class="one-name">
        <span>房源</span>
        <span>客源</span>
      </div>
      <a-divider />
      <div class="two-nameItem">
        <span>房源新增</span>
        <span>无效转有效</span>
        <span>房源跟进</span>
        <span>房源带看</span>
        <span>客源新增</span>
        <span>客源带看</span>
      </div>
      <!-- </div> -->
      <a-divider />
      <!-- 总计 -->
      <report-table :data="totalObj" style="padding-bottom: 10px"></report-table>
      <!-- 表格嵌套 -->

      <a-collapse
        @change="getGroup($event)"
        :bordered="false"
        :accordion="true"
        style="overflow:auto;"
        :style="{height:scrollHeight + 'px'}">
        <a-collapse-panel
          v-for="item in storeList"
          :key="item.storeId"
          :forceRender="false"
          :showArrow="true"
          style="background-color: #fff"
        >
          <no-data v-if="storeList.length === 0"> </no-data>
          <template v-else slot="header">
            <report-table :data="item" store="1" icon="icon"></report-table>
          </template>
          <a-spin :spinning="oneSpinning">
            <a-collapse @change="getPerson($event)" :bordered="false" :accordion="true">
              <a-collapse-panel
                v-for="g in groupList"
                :key="g.teamId"
                :forceRender="true"
                :showArrow="true"
                style="background-color: #f1f2f3"
              >
                <no-data v-if="groupList.length === 0"> </no-data>
                <template v-else slot="header">
                  <report-table :data="g" team="1" icon="icon"></report-table>
                </template>
                <a-spin :spinning="twoSpinning">
                  <no-data v-if="personalList.length === 0"> </no-data>
                  <report-table
                    v-else
                    :data="g"
                    v-for="g in personalList"
                    :key="g.id"
                    icon="icon"
                    person="1"
                    style="background-color: #ddd; padding: 10px 0"
                  ></report-table>
                </a-spin>
              </a-collapse-panel>
            </a-collapse>
          </a-spin>
        </a-collapse-panel>
      </a-collapse>
    </div>
  </div>
</template>

<script>
import achievementApi from '@/api/system/achievement/achievement.js'
import ReportTable from '@/components/reportTable/ReportTable.vue'
import { getCurrentDate, getBeginWeek, getBeginMonth, getquarterDay, getYearFirstDay } from '@/utils/date'

export default {
  name: 'Iufo',
  components: { ReportTable },
  data () {
    return {
      scrollHeight: 1000,
      form: {
        startDate: this.$moment(getBeginWeek()).format('YYYY-MM-DD'),
        endDate: this.$moment(getCurrentDate()).format('YYYY-MM-DD'),
        listType: '1', // 列表类型（1：门店 2：小组 3：个人）
        pageNum: 1,
        pageSize: 999,
        comprehensiveStatisticsSort: 1,
        sortType: 'DESC',
        storeId: '', //	门店ID
        teamId: '', // 部门ID
        userId: '' // 员工ID
      },
      totalObj: {},
      switchValue: true, // '是否显示离职人员'
      storeList: [],
      groupList: [],
      isShowArrow: true,
      personalList: [],
      currentDate: '本周',
      oneSpinning: false,
      twoSpinning: false

      // columns: [
      //   { title: '团队', dataIndex: 'store', key: 'store' },
      //   { title: '房源新增', dataIndex: 'cnewHouse', key: 'cnewHouse' },
      //   { title: '无效转有效', dataIndex: 'ceffective', key: 'ceffective' },
      //   { title: '房源跟进', dataIndex: 'cfollowHouse', key: 'cfollowHouse' },
      //   { title: '房源带看', dataIndex: 'lookByHouse', key: 'lookByHouse' },
      //   { title: '客源新增', dataIndex: 'cnewCustomer', key: 'cnewCustomer' },
      //   { title: '无效转有效', dataIndex: 'ccustomerEffective', key: 'ccustomerEffective' },
      //   { title: '客源带看', dataIndex: 'lookByCustomer', key: 'lookByCustomer' },
      // ],
    }
  },
  mounted () {
    window.addEventListener('scroll', this.menu)
  },
  methods: {
    menu () {
      const FIXOBJ = document.getElementById('warpper_page_body')
      const LIMITTOP = FIXOBJ.offsetTop
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop
      const CONH = document.body.clientHeight - 450
      if (this.scroll >= LIMITTOP) {
       this.scrollHeight = CONH
      } else {
      }
    },
    handleChange (e) {
      // this.isLoading = false
      // this.groupList = []
      if (e.target.value === '本周') {
        this.form.startDate = this.$moment(getBeginWeek()).format('YYYY-MM-DD')
        this.form.listType = '1'
        this.form.storeId = ''
        this.form.teamId = ''
        this.getDataList()
      } else if (e.target.value === '本月') {
        this.form.startDate = this.$moment(getBeginMonth()).format('YYYY-MM-DD')
        this.form.listType = '1'
        this.form.storeId = ''
        this.form.teamId = ''
        this.getDataList()
      } else if (e.target.value === '本季') {
        this.form.startDate = this.$moment(getquarterDay()).format('YYYY-MM-DD')
        this.form.listType = '1'
        this.form.storeId = ''
        this.form.teamId = ''
        this.getDataList()
      } else {
        this.form.startDate = this.$moment(getYearFirstDay()).format('YYYY-MM-DD')
        this.form.listType = '1'
        this.form.storeId = ''
        this.form.teamId = ''
        this.getDataList()
      }
      this.current = e.target.value
    },
    // 是否显示离职人员
    switchChange (checked) {
      this.storeList = []
      this.form = {
        startDate: this.form.startDate,
        endDate: this.form.endDate,
        listType: '1', // 列表类型（1：门店 2：小组 3：个人）
        pageNum: 1,
        pageSize: 999,
        comprehensiveStatisticsSort: 1,
        sortType: 'DESC',
        storeId: '', //	门店ID
        teamId: '', // 部门ID
        userId: '' // 员工ID
      }
      // this.getDataList()
      console.log(checked, this.switchValue, '显示开关数据')
    },

    // 获取门店列表
    getDataList () {
      achievementApi.comprehensiveStatistics({ ...this.form }).then((res) => {
        if (res.code === 200) {
          this.storeList = res.data.voPage.records
          this.totalObj = res.data.comprehensiveStatisticsVo
          console.log(this.storeList, this.totalObj, '综合报表数据')
        }
      })
    },

    // 获取小组列表
    getGroup (storeId) {
      if (!storeId) {
        this.form.listType = '1'
        this.form.storeId = ''
        return
      }
      this.form.listType = '2'
      this.form.storeId = storeId
      this.form.teamId = ''
      this.oneSpinning = true
      achievementApi.comprehensiveStatistics({ ...this.form }).then((res) => {
        this.oneSpinning = false
        if (res.code === 200) {
          this.groupList = res.data.voPage.records
        }
      })
    },

    // 获取个人列表
    getPerson (teamId) {
      console.log(teamId)
      if (!teamId) {
        this.form.listType = '2'
        this.form.teamId = ''
        return
      }
      this.form.listType = '3'
      this.form.teamId = teamId
      this.twoSpinning = true

      achievementApi.comprehensiveStatistics({ ...this.form }).then((res) => {
        this.twoSpinning = false
        if (res.code === 200) {
          // if (!this.switchValue) {
          //   this.personalList = (res.data.voPage.records || []).filter(item => item.delFlag === 0)
          // } else {
          //   this.personalList = res.data.voPage.records
          // }
          this.personalList = res.data.voPage.records
          console.log(this.personalList, 'personalList返回的数据')
        }
      })
    },
    // 查询
    handleClick () {
      this.form.listType = '1'
      this.form.storeId = ''
      this.form.teamId = ''
      this.getDataList()
    }
  },

  created () {
    this.getDataList()
  }
}
</script>

<style lang="less" scoped>
.iufo {
  height: 100%;
  .top {
    height: 160px;
    padding-left: 20px;
    padding-top: 20px;
    background-color: white;
    .name {
      color: #000;
      font-weight: 700;
      font-size: 20px;
    }
    .content {
      /deep/.ant-form {
        display: flex;
        align-items: center;
      }
      /deep/.ant-form-item {
        display: flex;
        margin-bottom: 0px;
      }
      .week-month-season-year {
        font-weight: 700;
        color: #000;
        padding-left: 10px;
        display: flex;
        justify-content: space-between;
      }
    }
  }
  .bottom {
    margin-top: 10px;
    padding: 40px;
    background-color: white;
    .one-name {
      color: #000;
      font-size: 16px;
      font-weight: 700;
      margin-left: 200px;
      display: flex;
      justify-content: space-around;
    }
    .two-nameItem {
      color: #000;
      font-weight: 700;
      margin-left: 240px;
      display: flex;
      justify-content: space-around;
    }
  }
}
/deep/.ant-collapse-item {
  border-bottom: none;
}
/deep/.ant-collapse-content-box {
  padding: 0px;
}
/deep/.ant-collapse-header {
  padding-top: 10px;
  padding-bottom: 10px;
}
/deep/.ant-collapse > .ant-collapse-item > .ant-collapse-header {
  padding-left: 0px;
  padding-right: 0px;
}

//时间样式
.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  /* background: var(--ThemeColor); */
  /* border-color: var(--ThemeColor); */
  color: var(--ThemeColor);
  background-color: #fff;
  // border: none;
  border-bottom: 2px solid var(--ThemeColor);
}

.ant-radio-button-wrapper {
  border: none;
}

.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
  background: #fff;
  color: var(--ThemeColor);
}

.ant-radio-button-wrapper:not(:first-child)::before {
  width: 0;
}

.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):focus-within {
  -webkit-box-shadow: 0 0 0 3px #fff;
  box-shadow: 0 0 0 3px #fff;
}

</style>
